import { ReactNode } from "react";
import { Navigate } from "react-router-dom";
// hooks
import useAuth from "../hooks/useAuth";
// routes
import { isAddingAccount } from "src/common/accountSession";
import { AGENT_URL, IS_AGENT } from "src/constants/settings";
import { PATH_AUTH, PATH_DASHBOARD } from "../routes/paths";

// ----------------------------------------------------------------------

type GuestGuardProps = {
  children: ReactNode;
};

export default function GuestGuard({ children }: GuestGuardProps) {
  const { isAuthenticated, is2FAPending } = useAuth(); // ✅ include is2FAPending

  const url = window.location.href;
  const fields = url.split("/");
  const loginRoutes = fields.includes("login");
  
  if (is2FAPending) {
    return <>{children}</>; // No redirect, just render as-is
  }

  if (isAuthenticated && !isAddingAccount()) {
    return <Navigate to={PATH_DASHBOARD.root} />;
  }

  // Only For Agent
  if (IS_AGENT && !isAuthenticated && fields[2] === AGENT_URL && !loginRoutes) {
    return <Navigate to={PATH_AUTH.login} />;
  }

  return <>{children}</>;
}
